var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRlefLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 24,
    viewBox: "0 0 160 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11924 5.8744C8.25443 5.8744 8.38318 5.8229 8.48941 5.73599C9.92179 4.51927 11.7791 3.78215 13.8005 3.78215C15.5805 3.78215 17.2672 4.33901 18.6899 5.3948C19.4432 5.95166 20.4957 5.94843 21.1749 5.30145C22.0472 4.47098 21.9378 3.10297 21.0172 2.41092C18.9217 0.833684 16.4271 0 13.8005 0C9.8027 0 6.25874 1.96672 4.07636 4.97956C3.80598 5.35295 4.07636 5.8744 4.53988 5.8744H8.11924Z",
    fill: "url(#paint0_linear_513_18317)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2948 7.95754C29.5384 7.23652 28.341 7.26227 27.6199 8.0187C27.2401 8.41462 26.5255 9.30946 25.2959 10.8545C23.3775 13.2654 20.1651 17.2954 18.9097 18.3061C17.6801 19.2943 16.2123 20.2117 13.8046 20.2117C11.3969 20.2117 9.2564 19.1817 7.75319 17.5433C7.64375 17.4242 7.49246 17.3534 7.33152 17.3534H4.03864C3.59766 17.3534 3.32084 17.8362 3.55259 18.2128C5.66094 21.6763 9.46884 23.9938 13.8078 23.9938C17.4162 23.9938 19.6983 22.5293 21.2852 21.2514C22.7466 20.0733 25.3088 16.9124 28.2605 13.2075C29.1553 12.0841 30.0824 10.9189 30.3624 10.626C31.0834 9.86953 31.0577 8.67212 30.3012 7.9511L30.2948 7.95754Z",
    fill: "url(#paint1_linear_513_18317)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9186 13.0282C46.2736 10.5218 44.5294 8.20213 42.0229 7.84719C39.5165 7.49225 37.1968 9.23641 36.8419 11.7429C36.487 14.2494 38.2311 16.569 40.7376 16.9239C43.2441 17.2789 45.5637 15.5347 45.9186 13.0282Z",
    fill: "#004047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2427 18.1211C38.1075 18.1211 37.9788 18.1726 37.8725 18.2595C36.4401 19.4762 34.5829 20.2133 32.5614 20.2133C30.7814 20.2133 29.0947 19.6565 27.672 18.6007C26.9188 18.0438 25.8662 18.0471 25.187 18.694C24.3147 19.5245 24.4242 20.8925 25.3448 21.5846C27.4402 23.1618 29.9348 23.9987 32.5614 23.9987C36.5592 23.9987 40.1032 22.032 42.2856 19.0192C42.556 18.6458 42.2856 18.1243 41.8221 18.1243H38.2427V18.1211Z",
    fill: "url(#paint2_linear_513_18317)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0681 16.0363C16.8245 16.7573 18.0219 16.7316 18.743 15.9752C19.1228 15.5792 19.8374 14.6844 21.067 13.1393C22.9854 10.7284 26.1978 6.69843 27.4532 5.68771C28.6828 4.69953 30.1506 3.78215 32.5583 3.78215C34.966 3.78215 37.1065 4.81218 38.6097 6.45058C38.7192 6.56968 38.8704 6.64049 39.0314 6.64049H42.3243C42.7652 6.64049 43.0421 6.15766 42.8103 5.78106C40.702 2.31757 36.8941 0 32.555 0C28.9467 0 26.6646 1.46458 25.0777 2.74246C23.6163 3.92056 21.0541 7.08147 18.1024 10.7864C17.2076 11.9097 16.2805 13.075 16.0005 13.3679C15.2795 14.1243 15.3052 15.3217 16.0617 16.0428L16.0681 16.0363Z",
    fill: "url(#paint3_linear_513_18317)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43664 16.9944C4.29072 14.6285 2.36907 12.7069 0 11.5577C2.36585 10.4118 4.28751 8.49017 5.43664 6.12109C6.58255 8.48695 8.5042 10.4086 10.8733 11.5577C8.50742 12.7036 6.58576 14.6253 5.43664 16.9944Z",
    fill: "#008F9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11924 5.8744C8.25443 5.8744 8.38318 5.8229 8.48941 5.73599C9.92179 4.51927 11.7791 3.78215 13.8005 3.78215C15.5805 3.78215 17.2672 4.33901 18.6899 5.3948C19.4432 5.95166 20.4957 5.94843 21.1749 5.30145C22.0472 4.47098 21.9378 3.10297 21.0172 2.41092C18.9217 0.833684 16.4271 0 13.8005 0C9.8027 0 6.25874 1.96672 4.07636 4.97956C3.80598 5.35295 4.07636 5.8744 4.53988 5.8744H8.11924Z",
    fill: "url(#paint4_linear_513_18317)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2948 7.95754C29.5384 7.23652 28.341 7.26227 27.6199 8.0187C27.2401 8.41462 26.5255 9.30946 25.2959 10.8545C23.3775 13.2654 20.1651 17.2954 18.9097 18.3061C17.6801 19.2943 16.2123 20.2117 13.8046 20.2117C11.3969 20.2117 9.2564 19.1817 7.75319 17.5433C7.64375 17.4242 7.49246 17.3534 7.33152 17.3534H4.03864C3.59766 17.3534 3.32084 17.8362 3.55259 18.2128C5.66094 21.6763 9.46884 23.9938 13.8078 23.9938C17.4162 23.9938 19.6983 22.5293 21.2852 21.2514C22.7466 20.0733 25.3088 16.9124 28.2605 13.2075C29.1553 12.0841 30.0824 10.9189 30.3624 10.626C31.0834 9.86953 31.0577 8.67212 30.3012 7.9511L30.2948 7.95754Z",
    fill: "url(#paint5_linear_513_18317)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9186 13.0282C46.2736 10.5218 44.5294 8.20213 42.0229 7.84719C39.5165 7.49225 37.1968 9.23641 36.8419 11.7429C36.487 14.2494 38.2311 16.569 40.7376 16.9239C43.2441 17.2789 45.5637 15.5347 45.9186 13.0282Z",
    fill: "#004047"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2427 18.1211C38.1075 18.1211 37.9788 18.1726 37.8725 18.2595C36.4401 19.4762 34.5829 20.2133 32.5614 20.2133C30.7814 20.2133 29.0947 19.6565 27.672 18.6007C26.9188 18.0438 25.8662 18.0471 25.187 18.694C24.3147 19.5245 24.4242 20.8925 25.3448 21.5846C27.4402 23.1618 29.9348 23.9987 32.5614 23.9987C36.5592 23.9987 40.1032 22.032 42.2856 19.0192C42.556 18.6458 42.2856 18.1243 41.8221 18.1243H38.2427V18.1211Z",
    fill: "url(#paint6_linear_513_18317)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0681 16.0363C16.8245 16.7573 18.0219 16.7316 18.743 15.9752C19.1228 15.5792 19.8374 14.6844 21.067 13.1393C22.9854 10.7284 26.1978 6.69843 27.4532 5.68771C28.6828 4.69953 30.1506 3.78215 32.5583 3.78215C34.966 3.78215 37.1065 4.81218 38.6097 6.45058C38.7192 6.56968 38.8704 6.64049 39.0314 6.64049H42.3243C42.7652 6.64049 43.0421 6.15766 42.8103 5.78106C40.702 2.31757 36.8941 0 32.555 0C28.9467 0 26.6646 1.46458 25.0777 2.74246C23.6163 3.92056 21.0541 7.08147 18.1024 10.7864C17.2076 11.9097 16.2805 13.075 16.0005 13.3679C15.2795 14.1243 15.3052 15.3217 16.0617 16.0428L16.0681 16.0363Z",
    fill: "url(#paint7_linear_513_18317)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43664 16.9944C4.29072 14.6285 2.36907 12.7069 0 11.5577C2.36585 10.4118 4.28751 8.49017 5.43664 6.12109C6.58255 8.48695 8.5042 10.4086 10.8733 11.5577C8.50742 12.7036 6.58576 14.6253 5.43664 16.9944Z",
    fill: "#008D9C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.88 14.7197V23.1627H57.4219V2.06641H66.6922C71.2919 2.06641 73.7672 4.59964 73.7672 7.85711C73.7672 10.6897 72.2254 12.2219 70.7029 12.8496C71.749 13.2358 73.323 14.3238 73.323 18.0995V19.1424C73.323 20.5619 73.3359 22.1778 73.6256 23.1627H69.3027C68.9325 22.2454 68.8617 20.6649 68.8617 18.4246V18.1156C68.8617 15.8077 68.2791 14.7165 64.88 14.7165H61.88V14.7197ZM61.88 11.0888H65.704C68.2018 11.0888 69.1642 10.1393 69.1642 8.37535C69.1642 6.61142 68.0441 5.70049 65.8134 5.70049H61.88V11.0921V11.0888Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8281 2.06641H82.3892V19.4257H92.8988L92.3773 23.166H77.8281V2.06962V2.06641Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.123 14.0631H100.035V19.4224H111.166L110.625 23.1627H95.6094V2.06641H110.567V5.80671H100.035V10.326H110.123V14.0663V14.0631Z",
    fill: "url(#paint8_linear_513_18317)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.426 2.06641H129.152V5.80671H118.881V10.9762H128.502V14.7165H118.881V23.166H114.426V2.06962V2.06641Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M131.742 23.1612V19.2148H133.271V23.1612H131.742Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140.918 15.761L138.195 23.1675H136.512L144.375 1.74609H146.332L154.534 23.1675H152.728L149.944 15.761H140.918ZM149.394 14.2288C147.008 7.86513 145.782 4.804 145.354 3.36517H145.322C144.8 4.98748 143.426 8.7825 141.498 14.2288H149.394Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.983 1.74609V23.1675H158.332V1.74609H159.983Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_513_18317",
    x1: 3.97014,
    y1: 2.93559,
    x2: 21.7736,
    y2: 2.93559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008F9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_513_18317",
    x1: 3.46246,
    y1: 15.715,
    x2: 30.8806,
    y2: 15.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_513_18317",
    x1: 42.3918,
    y1: 21.0599,
    x2: 24.5883,
    y2: 21.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_513_18317",
    x1: 45.2116,
    y1: 8.27888,
    x2: 17.7934,
    y2: 8.27888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008F9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_513_18317",
    x1: 3.97014,
    y1: 2.93559,
    x2: 21.7736,
    y2: 2.93559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_513_18317",
    x1: 3.46246,
    y1: 15.715,
    x2: 30.8806,
    y2: 15.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_513_18317",
    x1: 42.3918,
    y1: 21.0599,
    x2: 24.5883,
    y2: 21.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_513_18317",
    x1: 45.2116,
    y1: 8.27888,
    x2: 17.7934,
    y2: 8.27888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_513_18317",
    x1: 103.386,
    y1: 2.06319,
    x2: 103.386,
    y2: 23.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#00828F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#00636D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004047"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRlefLogo);
export default __webpack_public_path__ + "static/media/rlef-logo.b2343cc8b4d2730922446dda24872980.svg";
export { ForwardRef as ReactComponent };